import { render, staticRenderFns } from "./AtlasReport.vue?vue&type=template&id=2b0a99da&"
import script from "./AtlasReport.vue?vue&type=script&lang=js&"
export * from "./AtlasReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports